// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 15) return "static/js/75fa84a15e621433d88a.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"bc4bd7bb845059556eef","215":"a264f77cb977ab1485e4","216":"d2f56b2f5e3f56b5d57e"}[chunkId] + ".chunk.js";
};